import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function NavItem({
  children, className, fl, icon, onClick,
}) {
  return (
    <li className="sidemenu__nav-item">
      <button
        className="button--link sidemenu__nav-link"
        onClick={onClick}
        type="button"
      >
        <i className={classnames(makeClassName({ fl, icon }), className)} />
        {' '}
        {children}
      </button>
    </li>
  );
}

function makeClassName({ fl, icon }) {
  if (fl) {
    return `fl-ico fl-ico-${icon} sidemenu__nav-icon sidemenu__nav-icon--fl-ico`;
  }
  return `fa fa-${icon} sidemenu__nav-icon`;
}

NavItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fl: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

NavItem.defaultProps = {
  className: '',
  fl: false,
};